<template>
    <b-modal size="lg" hide-footer :title="prefix + title + ' > Visualizar Imagem'" @hidden="cancelar" v-model="modalAberto">
        <div class="text-center">
            <img :src="'data:image/jpeg;base64, ' + imageBytes" alt="Foto do Produto" class="img-fluid" />
        </div>
    </b-modal>
</template>

<script>
export default {
    props: {
        imageBytes: {
            type: String,
            required: true,
        },
        prefix: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            default: "> Visualizar Produto",
        },
        id: Number,
    },

    watch: {
        modalAberto(value) {
            if (!value) {
                this.$emit("close");
            }
        },
    },
    data() {
        return {
            modalAberto: true,
        };
    },
    methods: {
        cancelar() {
            this.modalAberto = false;
        },
    },
};
</script>